"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../../../../../common/hooks/use-translation-wrapper");
const BondDeleteModalModal = ({ isOpen, onConfirm, onCancel }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (React.createElement(react_core_1.Modal, { "aria-label": t('ai:Remove bond dialog'), title: t('ai:Remove bond?'), isOpen: isOpen, onClose: onCancel, hasNoBodyWrapper: true, id: "remove-bond-modal", variant: "medium", titleIconVariant: "warning" },
        React.createElement(react_core_1.ModalBoxBody, null,
            React.createElement(react_core_1.Stack, { hasGutter: true },
                React.createElement(react_core_1.StackItem, null, t('ai:The bond associated with the host will be removed.')))),
        React.createElement(react_core_1.ModalBoxFooter, null,
            React.createElement(react_core_1.Button, { onClick: onConfirm, variant: react_core_1.ButtonVariant.danger }, t('ai:Remove bond')),
            React.createElement(react_core_1.Button, { onClick: onCancel, variant: react_core_1.ButtonVariant.secondary }, t('ai:Cancel')))));
};
exports.default = BondDeleteModalModal;
//# sourceMappingURL=BondsConfirmationModal.js.map